var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogoAgopFgFh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.984 6.83301C18.984 6.83301 18.8049 5.56901 18.2535 5.014C17.5553 4.28353 16.7747 4.27995 16.4166 4.23698C13.8528 4.05078 10.0035 4.05078 10.0035 4.05078H9.99634C9.99634 4.05078 6.14705 4.05078 3.58325 4.23698C3.22518 4.27995 2.44458 4.28353 1.74634 5.014C1.19491 5.56901 1.01945 6.83301 1.01945 6.83301C1.01945 6.83301 0.833252 8.31901 0.833252 9.80143V11.1908C0.833252 12.6732 1.01587 14.1592 1.01587 14.1592C1.01587 14.1592 1.19491 15.4232 1.74276 15.9782C2.441 16.7087 3.35767 16.6836 3.76587 16.7624C5.23397 16.902 9.99992 16.945 9.99992 16.945C9.99992 16.945 13.8528 16.9378 16.4166 16.7552C16.7747 16.7122 17.5553 16.7087 18.2535 15.9782C18.8049 15.4232 18.984 14.1592 18.984 14.1592C18.984 14.1592 19.1666 12.6768 19.1666 11.1908V9.80143C19.1666 8.31901 18.984 6.83301 18.984 6.83301ZM8.10571 12.8773V7.72461L13.0579 10.3099L8.10571 12.8773Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogoAgopFgFh);
export default __webpack_public_path__ + "static/media/youtube-logo-AGOPFgFh.21dc89d632c4c00559a7a2cb23bdb7e9.svg";
export { ForwardRef as ReactComponent };